import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import { DrawerCard } from "scmp-app/components/common/drawer/styles";
import { Header as RefineSearchHeader } from "scmp-app/components/search/search-result-panel/refine-search/styles";

import { DynamicDrawer } from "./dynamics";
import CloseIconSvg from "./icon-close.svg";

export const StyledDynamicDrawer = styled(DynamicDrawer)`
  ${theme.breakpoints.up("desktop")} {
    display: none;
  }

  ${DrawerCard} {
    block-size: 100%;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 300px;
  block-size: 100%;
  padding: 16px;
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding-block-end: 16px;

  border-block-end: 1px #727272 solid;
`;

export const CloseButton = styled.button`
  padding: 0;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;

export const StyledCloseIcon = styled(CloseIconSvg)`
  inline-size: 20px;
  block-size: 20px;

  color: #727272;
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const ResetButton = styled.button`
  padding: 0;

  color: #2c4692;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;

export const Body = styled.div`
  flex: 1 1 auto;

  ${RefineSearchHeader} {
    display: none;
  }
`;

export const ApplyButton = styled.button`
  inline-size: 100%;
  padding-block: 8px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  border: none;
  border-radius: 4px;

  background-color: #2c4692;

  cursor: pointer;
`;
